import { Link } from 'react-router-dom'
import { BottleIcon } from './Icon'
import s from './Logo.module.css'

type LogoProps = {
  /** Footer lockup: 26px tile, 17px wordmark. */
  small?: boolean
  /** Render as a link to `/`. The landing page's own nav uses the plain form. */
  asLink?: boolean
}

export function Logo({ small = false, asLink = false }: LogoProps) {
  const className = small ? `${s.logo} ${s.small}` : s.logo
  const inner = (
    <>
      <span className={s.tile}>
        <BottleIcon size={small ? 16 : 21} detail={!small} />
      </span>
      <span className={s.wordmark}>TINY BOSS</span>
    </>
  )

  if (asLink) {
    return (
      <Link to="/" className={className} aria-label="Tiny Boss — home">
        {inner}
      </Link>
    )
  }

  return <span className={className}>{inner}</span>
}
